import { Component, OnInit, ViewChild, ViewEncapsulation, Injector } from '@angular/core';
import { DataTable } from 'primeng/components/datatable/datatable';
import { Paginator } from 'primeng/components/paginator/paginator';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { LazyLoadEvent } from 'primeng/components/common/lazyloadevent';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { CreateOrEditEventModalComponent } from '@app/event/events/modals/create-or-edit/create-or-edit-event-modal.component';
import { EventsServiceProxy, EventDto, EntityDto, EventTypesServiceProxy, PublishEventInput } from '@shared/service-proxies/service-proxies';
import { AdjustDeadlineForPublishModalComponent } from '@app/event/events/modals/adjust-deadline-for-publish/adjust-deadline-for-publish-modal.component';
import { StatusIntegracao } from '@shared/AppEnums';

@Component({
  templateUrl: './events.component.html',
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()]
})
export class EventsComponent extends AppComponentBase implements OnInit {

  @ViewChild('createOrEditEventModal') createOrEditEventModal: CreateOrEditEventModalComponent;
  @ViewChild('adjustDeadlineForPublishModal') adjustDeadlineForPublishModal: AdjustDeadlineForPublishModalComponent;
  @ViewChild('dataTable') dataTable: DataTable;
  @ViewChild('paginator') paginator: Paginator;

  statusIntegracao = StatusIntegracao;

  //Filters
  filterText = '';
  filterEventTypeDescription = undefined;
  advancedFiltersAreShown = false;
  filterStatusIntegracao = undefined;

  types = [];
  downloadingExcel = false;

  constructor(
    injector: Injector,
    private _eventsService: EventsServiceProxy,
    private _fileDownloadService: FileDownloadService,
    private _eventTypesService: EventTypesServiceProxy
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this._eventTypesService.getEventTypesForSelect("").subscribe(result => {
      this.types = result.items;
    });
  }

  getEvents(event?: LazyLoadEvent) {

    if (this.primengDatatableHelper.shouldResetPaging(event)) {
      this.paginator.changePage(0);
      return;
    }

    this.primengDatatableHelper.showLoadingIndicator();

    this._eventsService.getAll(
      this.filterText,
      this.filterEventTypeDescription,
      this.filterStatusIntegracao,
      this.primengDatatableHelper.getSorting(this.dataTable),
      this.primengDatatableHelper.getSkipCount(this.paginator, event),
      this.primengDatatableHelper.getMaxResultCount(this.paginator, event)
    )
      .finally(() => {
        this.primengDatatableHelper.hideLoadingIndicator();
      })
      .subscribe(result => {
        this.primengDatatableHelper.totalRecordsCount = result.totalCount;
        this.primengDatatableHelper.records = result.items;
      });
  }

  clear(): void {
    this.filterText = '';
    this.filterEventTypeDescription = undefined;
  }

  createEvent(): void {
    this.createOrEditEventModal.show();
  }

  duplicate(event: EventDto): void {

    let msg = this.l('Event') + ' ' + event.name + ' ' + this.l('will be duplicate.');

    this.message.confirm(
      msg,
      (isConfirmed) => {
        if (isConfirmed) {

          let input = new EntityDto();
          input.id = event.id

          this._eventsService.copyEvent(input)
            .subscribe(() => {
              this.reloadPage();
              this.notify.success(this.l('SavedSuccessfully'));
            });
        }
      }
    );
  }

  publishConfirmation(event: EventDto) {

    let msg = this.l('Event') + ' ' + event.name + ' ' + this.l('will be published.');

    this.message.confirm(
      msg,
      (isConfirmed) => {
        if (isConfirmed) {

          let input = new PublishEventInput();
          input.eventId = event.id;

          this._eventsService.publish(input)
            .subscribe(() => {
              this.reloadPage();
              this.notify.success(this.l('SavedSuccessfully'));
            });
        }
      }
    );
  }

  cancelPublish(event: EventDto): void {

    let msg = this.l('Event') + ' ' + event.name + ' ' + this.l('will be cancel the publication.');

    this.message.confirm(
      msg,
      (isConfirmed) => {
        if (isConfirmed) {

          let input = new EntityDto();
          input.id = event.id

          this._eventsService.cancelPublish(input)
            .subscribe(() => {
              this.reloadPage();
              this.notify.success(this.l('SavedSuccessfully'));
            });
        }
      }
    );
  }

  addToCalendar(event: EventDto){
    let msg = this.l('Event') + ' ' + event.name + ' ' + this.l('will be added') + ' ao Google Calendar.';

    this.message.confirm(
      msg,
      (isConfirmed) => {
        if (isConfirmed) {

          let input = new PublishEventInput();
          input.eventId = event.id;

          this._eventsService.addToGoogleCalendar(input)
            .subscribe(() => {
              this.reloadPage();
              this.notify.success(this.l('SavedSuccessfully'));
            });
        }
      }
    );
  }

  removeFromCalendar(event: EventDto){
    let msg = this.l('Event') + ' ' + event.name + ' ' + this.l('will be removed') + ' do Google Calendar';

    this.message.confirm(
      msg,
      (isConfirmed) => {
        if (isConfirmed) {

          let input = new PublishEventInput();
          input.eventId = event.id;

          this._eventsService.removeFromGoogleCalendar(input.eventId)
            .subscribe(() => {
              this.reloadPage();
              this.notify.success(this.l('SavedSuccessfully'));
            });
        }
      }
    );
  }

  delete(event: EventDto): void {

    let msg = this.l('Event') + ' ' + event.name + ' ' + this.l('will be deleted.');

    this.message.confirm(
      msg,
      (isConfirmed) => {
        if (isConfirmed) {
          this._eventsService.deleteEvent(event.id)
            .subscribe(() => {
              this.reloadPage();
              this.notify.success(this.l('SuccessfullyDeleted'));
            });
        }
      }
    );
  }

  reloadPage(): void {
    this.paginator.changePage(this.paginator.getPage());
  }

  exportToExcel(): void {

    this.downloadingExcel = true;

    this._eventsService.getEventsToExcel(this.filterText, this.filterStatusIntegracao)
      .finally(() => {
        this.downloadingExcel = false;
      })
      .subscribe(result => {
        this._fileDownloadService.downloadTempFile(result);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/event/events/events.component.ts